export default __webpack_public_path__ + "static/media/Rapporteuse.b03657ca.jpg";